/**
 * Stores the Configuration setting information, and the selected value (if any)
 * @typedef {object} ConfigurationAndSelection
 * @property {string} name - the name of this configuration setting.
 * @property {string} contentType - the contentType restriction of this config setting.
 * @property {?string} typeElementId - the id of the Type restriction of this config value.
 * @property {?ValueSelectorMetadata} value - the information about the selected value reference for this config setting.
 * @property {?string|number|Date|boolean} default - if the service is a supported service, then this stores the default value of this config value
 * @property {?string} description - if the service is a supported service, then this stores a small description of this config value
 * 
 * All information about the installed Service
 * @typedef {Object} ServiceData
 * @property {ServiceAction[]} actions
 * @property {ServiceValue[]} configurationValues
 * @property {string} dateCreated
 * @property {string} dateModified
 * @property {string} developerName
 * @property {string} developerSummary
 * @property {string} elementType
 * @property {string} format
 * @property {string} httpAuthenticationPassword
 * @property {string} httpAuthenticationUsername
 * @property {string} id
 * @property {ServiceInstall} install
 * @property {boolean} providesAutoBinding
 * @property {boolean} providesDatabase
 * @property {boolean} providesFiles
 * @property {boolean} providesIdentity
 * @property {boolean} providesLocation
 * @property {boolean} providesLogic
 * @property {boolean} providesSocial
 * @property {boolean} providesViews
 * @property {boolean} sendDecryptedValues
 * @property {boolean} updateByName
 * @property {string} uri
 * @property {string} version
 * @property {User} whoCreated
 * @property {User} whoModified
 * @property {User} whoOwner
 *
 * Information about an Action the Service can perform
 * @typedef {Object} ServiceAction
 * @property {string} developerName
 * @property {string} developerSummary
 * @property {boolean} isViewMessageAction
 * @property {ServiceActionOutcomes[]} serviceActionOutcomes
 * @property {ServiceValue[]} serviceInputs
 * @property {ServiceValue[]} serviceOutputs
 * @property {string} uriPart
 *
 * @typedef {Object} ServiceActionOutcomes
 * @property {string} developerName
 * @property {string} developerSummary
 * @property {string} id
 *
 * When installed, this Service will create/has created the following Types
 * @typedef {Object} ServiceInstall
 * @property {Type[]} typeElements
 */
